import React from 'react';
import {MasterLayout} from 'components/layouts';
import {NeedOfferDetail} from 'components/my-business';
import title from 'constants/TitlePages.js';
import {BusinessLayout} from 'components/layouts/business';

class NeedOfferDetailPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.NeedOfferDetailPage;
  }

  render() {
    return (
      <MasterLayout>
        <BusinessLayout active='need-offer'>
          <NeedOfferDetail params={this.props.match.params}/>
        </BusinessLayout>
      </MasterLayout>
    );
  }
}

export default NeedOfferDetailPage;



// WEBPACK FOOTER //
// ./pages/need-offer/NeedOfferDetailPage.jsx